/** Format a calendar due date (YYYY-MM-DD or ISO) without TZ day-shift. */
export const formatGoalDueLabel = (isoDate: string): string => {
  if (!isoDate) return ""
  const datePart = isoDate.slice(0, 10)
  const date = new Date(`${datePart}T12:00:00`)
  if (Number.isNaN(date.getTime())) return isoDate

  const today = new Date()
  today.setHours(12, 0, 0, 0)
  const tomorrow = new Date(today)
  tomorrow.setDate(tomorrow.getDate() + 1)

  if (date.toDateString() === today.toDateString()) return "Today"
  if (date.toDateString() === tomorrow.toDateString()) return "Tomorrow"

  return date.toLocaleDateString("en-IE", {
    weekday: "short",
    day: "numeric",
    month: "short",
  })
}
